import React from 'react';

/**
 * Badge — compact status / severity label. Security-focused tones:
 * secure, warning, critical, info, neutral. Optional dot.
 */
export function Badge({ tone = 'neutral', variant = 'soft', dot = false, children, style = {}, ...rest }) {
  const tones = {
    secure:   { fg: 'var(--secure-700)', bg: 'var(--secure-100)', solidBg: 'var(--secure-600)' },
    warning:  { fg: 'var(--warn-700)',   bg: 'var(--warn-100)',   solidBg: 'var(--warn-600)' },
    critical: { fg: 'var(--crit-700)',   bg: 'var(--crit-100)',   solidBg: 'var(--crit-600)' },
    info:     { fg: 'var(--brand-700)',  bg: 'var(--brand-100)',  solidBg: 'var(--brand-600)' },
    neutral:  { fg: 'var(--ink-600)',    bg: 'var(--ink-100)',    solidBg: 'var(--ink-600)' },
  };
  const t = tones[tone] || tones.neutral;
  const solid = variant === 'solid';
  return (
    <span
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        height: 22, padding: '0 9px', borderRadius: 'var(--radius-full)',
        fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xs)', fontWeight: 'var(--fw-semibold)',
        letterSpacing: '0.01em', lineHeight: 1, whiteSpace: 'nowrap',
        color: solid ? 'var(--white)' : t.fg,
        background: solid ? t.solidBg : t.bg,
        ...style,
      }}
      {...rest}
    >
      {dot && <span style={{ width: 6, height: 6, borderRadius: '50%', background: solid ? 'var(--white)' : t.solidBg, flexShrink: 0 }} />}
      {children}
    </span>
  );
}
